import {
  filterProductOptions,
  filterProductOptionsV2,
} from "./product-filtering"

const displayOptionHeading = (wizardData, pref, choices) => {
  let heading = wizardData?.heading?.title

  if (wizardData?.heading?.titles?.options) {
    const titleOptions = filterProductOptionsV2(
      wizardData.heading.titles.options,
      choices
    )
    if (titleOptions.length) {
      heading = titleOptions[0].label
    }
  }

  if (pref === "ef" || pref === "ef2") {
    const fontValue = choices[pref]?.display_name ?? choices[pref]?.value

    if (fontValue) {
      const filteredOptions = filterProductOptions(
        wizardData?.options || [],
        choices,
        true
      )
      if (filteredOptions.length > 1) {
        heading = `${heading} (${fontValue})`
      }
    }
  }

  return heading
}

export default displayOptionHeading
